(function () {
  'use strict';

  function prefersReducedMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function initHeroScroll() {
    document.querySelectorAll('[data-lp-dealer-scroll]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        var targetSel = btn.getAttribute('data-lp-dealer-scroll');
        if (!targetSel) return;
        var el = document.querySelector(targetSel);
        if (!el) return;
        e.preventDefault();
        el.scrollIntoView({ behavior: prefersReducedMotion() ? 'auto' : 'smooth', block: 'start' });
      });
    });
  }

  function initProcessReveal() {
    document.querySelectorAll('[data-lp-dealer-process]').forEach(function (track) {
      if (track.getAttribute('data-lp-dealer-process-init') === 'true') return;
      track.setAttribute('data-lp-dealer-process-init', 'true');

      var steps = track.querySelectorAll('.lp-dealer-process__step');
      if (!steps.length) return;

      if (prefersReducedMotion()) {
        steps.forEach(function (s) {
          s.classList.add('is-revealed');
        });
        return;
      }

      var io = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            var step = entry.target;
            var index = Array.prototype.indexOf.call(steps, step);
            setTimeout(
              function () {
                step.classList.add('is-revealed');
              },
              index * 120
            );
            io.unobserve(step);
          });
        },
        { root: null, rootMargin: '0px 0px -8% 0px', threshold: 0.15 }
      );

      steps.forEach(function (step) {
        io.observe(step);
      });
    });
  }

  /** ISO 3166-1 alpha-2 → [longitude, latitude] approximate center */
  var ISO_COORDS = {
    AD: [1.6, 42.5],
    AE: [54, 24],
    AF: [66, 33],
    AG: [-61.8, 17.1],
    AL: [20, 41],
    AM: [45, 40],
    AO: [18, -12],
    AR: [-64, -34],
    AT: [14, 47],
    AU: [134, -25],
    AZ: [47.5, 40.5],
    BA: [18, 44],
    BD: [90, 24],
    BE: [4.5, 50.5],
    BG: [25, 43],
    BH: [50.5, 26],
    BN: [114.7, 4.5],
    BO: [-65, -17],
    BR: [-52, -10],
    BS: [-76, 24],
    BT: [90.5, 27.5],
    BW: [24, -22],
    BY: [28, 53],
    BZ: [-88.7, 17.2],
    CA: [-96, 54],
    CH: [8, 47],
    CL: [-71, -35],
    CN: [105, 35],
    CO: [-74, 4],
    CR: [-84, 10],
    CU: [-79.5, 21.5],
    CY: [33, 35],
    CZ: [15.5, 49.8],
    DE: [10.5, 51],
    DK: [10, 56],
    DO: [-70.5, 19],
    DZ: [3, 28],
    EC: [-78.5, -1.5],
    EE: [26, 59],
    EG: [30, 27],
    ES: [-4, 40],
    FI: [26, 64],
    FR: [2, 46],
    GB: [-2, 54],
    GE: [43.5, 42],
    GH: [-1, 8],
    GR: [22, 39],
    GT: [-90.5, 15.5],
    HK: [114.2, 22.3],
    HN: [-86.5, 15],
    HR: [16, 45],
    HU: [19.5, 47],
    ID: [118, -2],
    IE: [-8, 53],
    IL: [35, 31.5],
    IN: [78, 22],
    IQ: [44, 33],
    IR: [53, 32],
    IS: [-19, 65],
    IT: [12.5, 42.8],
    JM: [-77.3, 18.1],
    JO: [36, 31],
    JP: [138, 36],
    KE: [38, 0],
    KG: [75, 41],
    KH: [105, 13],
    KR: [127.5, 36],
    KW: [48, 29.5],
    KZ: [68, 48],
    LA: [103, 18],
    LB: [35.8, 33.9],
    LK: [81, 7],
    LT: [24, 56],
    LU: [6.1, 49.8],
    LV: [25, 57],
    MA: [-7, 32],
    MD: [29, 47],
    ME: [19.3, 42.7],
    MK: [21.7, 41.6],
    MM: [96, 22],
    MN: [105, 46],
    MO: [113.5, 22.2],
    MT: [14.4, 35.9],
    MX: [-102, 23],
    MY: [112, 4],
    NG: [8, 10],
    NL: [5.5, 52.3],
    NO: [10, 61],
    NP: [84, 28],
    NZ: [174, -41],
    OM: [57, 21],
    PA: [-80, 9],
    PE: [-76, -10],
    PH: [122, 12],
    PK: [69, 30],
    PL: [19, 52],
    PT: [-8, 39.5],
    PY: [-58, -23],
    QA: [51.2, 25.3],
    RO: [25, 46],
    RS: [21, 44],
    RU: [37, 55],
    SA: [45, 24],
    SE: [16, 62],
    SG: [103.8, 1.35],
    SI: [15, 46],
    SK: [19.5, 48.7],
    TH: [101, 15],
    TR: [35, 39],
    TW: [121, 24],
    TZ: [35, -6],
    UA: [32, 49],
    US: [-98, 39],
    UY: [-56, -33],
    UZ: [64, 41],
    VE: [-66, 8],
    VN: [106, 16],
    ZA: [25, -29],
    ZM: [28, -15],
    ZW: [29, -19]
  };

  /** PNG 1586×992: equirectangular land band with ~10% vertical letterbox */
  var MAP_INSET = { left: 0, top: 0.1004, right: 0, bottom: 0.1004 };

  /** Snapped to land pixels on shop map PNG 126c16afc… */
  var LEGACY_PHOTO_OVERRIDES = {
    AD: [49.8, 30.7],
    AE: [65.2, 38.1],
    AF: [69.3, 36.3],
    AG: [33.3, 42.4],
    AL: [55.3, 31.8],
    AM: [62, 32],
    AO: [55.9, 55.3],
    AR: [33.2, 65.1],
    AT: [53.9, 29.2],
    AU: [86.7, 61.2],
    AZ: [62.2, 32],
    BA: [54.5, 30.5],
    BD: [75, 40.4],
    BE: [50.7, 27.5],
    BG: [57, 30.9],
    BH: [64.4, 38.4],
    BN: [82.5, 48],
    BO: [30.8, 57.5],
    BR: [36.8, 54.5],
    BS: [29.4, 39.4],
    BT: [74.3, 38.1],
    BW: [57.3, 59.7],
    BY: [57.9, 26.4],
    BZ: [25.6, 42.4],
    CA: [23, 26],
    CH: [52.4, 29.2],
    CL: [30.8, 65.6],
    CN: [79.1, 34.4],
    CO: [29.6, 48.2],
    CR: [27.7, 45.1],
    CU: [27.9, 40.5],
    CY: [58.9, 34.4],
    CZ: [54.6, 27.6],
    DE: [53.4, 25.3],
    DK: [53.4, 25.3],
    DO: [30, 41.6],
    DZ: [50.1, 37.5],
    EC: [29.1, 50.7],
    EE: [57, 23.8],
    EG: [58, 38],
    ES: [49.3, 32.2],
    FI: [57, 21.6],
    FR: [49.9, 29.6],
    GB: [49.8, 26.8],
    GE: [62.2, 31.4],
    GH: [49.8, 46.4],
    GR: [55.3, 32.7],
    GT: [25.6, 43.1],
    HK: [82.2, 40.9],
    HN: [25.6, 43.3],
    HR: [54.6, 30],
    HU: [55.9, 29.8],
    ID: [82.9, 50.9],
    IE: [48.1, 26.2],
    IL: [58, 36],
    IN: [72.6, 40.3],
    IQ: [62.6, 35.3],
    IR: [65.2, 35.8],
    IS: [44.6, 21.1],
    IT: [53.9, 31],
    JM: [27.9, 42],
    JO: [60.9, 33.6],
    JP: [87.9, 33.4],
    KE: [61.3, 50.6],
    KG: [71.5, 31.8],
    KH: [79.1, 44.4],
    KR: [85.7, 33.8],
    KW: [63.1, 36.9],
    KZ: [69.3, 28.7],
    LA: [78, 42],
    LB: [60.7, 33.9],
    LK: [72, 46.9],
    LT: [57.9, 25.1],
    LU: [51.2, 27.9],
    LV: [57, 24.7],
    MA: [47.4, 35.2],
    MD: [58, 29.2],
    ME: [55.3, 31.1],
    MK: [55.9, 31.5],
    MM: [76.5, 40.3],
    MN: [79.1, 29.6],
    MO: [80.9, 40.2],
    MT: [53.9, 34.1],
    MX: [21.8, 40.8],
    MY: [81.4, 48.2],
    NG: [53.1, 47.5],
    NL: [51.2, 26.7],
    NO: [51.5, 22.9],
    NP: [73.7, 37.5],
    NZ: [97, 68.2],
    OM: [65.8, 40.7],
    PA: [27.8, 46],
    PE: [30, 53.7],
    PH: [83.8, 44.7],
    PK: [69.8, 36.6],
    PL: [54.8, 26.7],
    PT: [48.1, 32.5],
    PY: [33.2, 60.2],
    QA: [65.2, 38.1],
    RO: [57, 29.6],
    RS: [55.3, 30.5],
    RU: [60.3, 25.7],
    SA: [63.4, 39.4],
    SE: [54.6, 22.5],
    SG: [80.3, 49.4],
    SI: [54.6, 29.6],
    SK: [54.5, 28.4],
    TH: [77.9, 43.3],
    TR: [60.9, 32.7],
    TW: [83.3, 38.7],
    TZ: [59, 53.5],
    UA: [58, 28.3],
    US: [20.9, 29.7],
    UY: [37, 64.7],
    UZ: [67, 31.2],
    VE: [30.8, 46.4],
    VN: [79.1, 42.9],
    ZA: [55.3, 61.3],
    ZM: [57.9, 56.7],
    ZW: [57.9, 58.4]
  };

  /*
   * Native pixel coordinates for Shopify map image 126c16afc1078ebcb225e0cd780092f2
   * The source image is 1586 x 992 and does not use a simple rectangular
   * longitude/latitude projection. Calibrated source pixels stay aligned
   * when the same image is resized responsively.
   */
  var PHOTO_MAP_SIZE = { width: 1586, height: 992 };
  var PHOTO_POINTS_PX = {
    AE: [1008, 487],
    AL: [852, 438],
    AR: [478, 756],
    AT: [825, 394],
    AU: [1342, 762],
    AZ: [958, 426],
    BA: [839, 419],
    BD: [1151, 528],
    BE: [783, 370],
    BG: [875, 432],
    BR: [512, 635],
    BY: [885, 355],
    CA: [292, 286],
    CH: [778, 396],
    CL: [445, 767],
    CN: [1200, 458],
    CO: [433, 580],
    HR: [833, 414],
    CZ: [827, 385],
    DE: [806, 371],
    DK: [804, 330],
    EE: [875, 312],
    EG: [901, 485],
    ES: [733, 415],
    FI: [860, 250],
    FR: [777, 389],
    GB: [736, 332],
    GE: [933, 422],
    GR: [857, 454],
    HK: [1253, 510],
    HU: [846, 403],
    ID: [1245, 650],
    IE: [710, 350],
    IL: [927, 467],
    IN: [1092, 526],
    IS: [830, 194],
    IT: [820, 421],
    JP: [1383, 400],
    KR: [1331, 433],
    KZ: [1045, 386],
    LT: [870, 340],
    LU: [789, 378],
    LV: [876, 327],
    MA: [746, 460],
    MD: [882, 406],
    ME: [846, 429],
    MK: [860, 440],
    MN: [1185, 382],
    MX: [305, 505],
    MY: [1220, 615],
    NG: [793, 585],
    NL: [786, 357],
    NO: [790, 245],
    NZ: [1488, 852],
    PE: [420, 640],
    PH: [1315, 570],
    PK: [1040, 485],
    PL: [846, 372],
    PT: [712, 420],
    RO: [870, 413],
    RS: [851, 423],
    RU: [1070, 275],
    SA: [966, 505],
    SE: [813, 267],
    SG: [1229, 628],
    SI: [822, 405],
    SK: [843, 391],
    TH: [1183, 560],
    TR: [922, 452],
    TW: [1297, 511],
    UA: [898, 387],
    US: [334, 405],
    VN: [1220, 570],
    ZA: [849, 755]
  };

  var ISO_PHOTO_XY = {};

  function rebuildPhotoXY() {
    ISO_PHOTO_XY = {};
    Object.keys(PHOTO_POINTS_PX).forEach(function (code) {
      var point = PHOTO_POINTS_PX[code];
      ISO_PHOTO_XY[code] = [
        (point[0] / PHOTO_MAP_SIZE.width) * 100,
        (point[1] / PHOTO_MAP_SIZE.height) * 100
      ];
    });
  }

  function photoProject(lng, lat, inset) {
    inset = inset || MAP_INSET;
    var innerW = 1 - inset.left - inset.right;
    var innerH = 1 - inset.top - inset.bottom;
    var x = (inset.left + ((lng + 180) / 360) * innerW) * 100;
    var y = (inset.top + ((90 - lat) / 180) * innerH) * 100;
    return {
      x: Math.max(1, Math.min(99, x)),
      y: Math.max(1, Math.min(99, y))
    };
  }

  function readMapInsetFromWrap(mapWrap) {
    var inset = {
      left: MAP_INSET.left,
      top: MAP_INSET.top,
      right: MAP_INSET.right,
      bottom: MAP_INSET.bottom
    };
    var l = parseFloat(mapWrap.getAttribute('data-map-inset-left'));
    var t = parseFloat(mapWrap.getAttribute('data-map-inset-top'));
    var r = parseFloat(mapWrap.getAttribute('data-map-inset-right'));
    var b = parseFloat(mapWrap.getAttribute('data-map-inset-bottom'));
    if (!isNaN(l)) inset.left = l / 100;
    if (!isNaN(t)) inset.top = t / 100;
    if (!isNaN(r)) inset.right = r / 100;
    if (!isNaN(b)) inset.bottom = b / 100;
    return inset;
  }

  function getContainedImageBox(img) {
    var boxW = img.clientWidth;
    var boxH = img.clientHeight;
    var nw = img.naturalWidth;
    var nh = img.naturalHeight;
    if (!boxW || !boxH || !nw || !nh) {
      return { offsetX: 0, offsetY: 0, width: boxW, height: boxH };
    }
    var imageAspect = nw / nh;
    var boxAspect = boxW / boxH;
    if (boxAspect > imageAspect) {
      var renderH = boxH;
      var renderW = boxH * imageAspect;
      return { offsetX: (boxW - renderW) / 2, offsetY: 0, width: renderW, height: renderH };
    }
    var renderW2 = boxW;
    var renderH2 = boxW / imageAspect;
    return { offsetX: 0, offsetY: (boxH - renderH2) / 2, width: renderW2, height: renderH2 };
  }

  function applyMapWrapAspect(mapWrap, img) {
    if (img.naturalWidth > 0 && img.naturalHeight > 0) {
      mapWrap.style.aspectRatio = img.naturalWidth + ' / ' + img.naturalHeight;
    }
  }

  var REGION_ORDER = {
    'North America': 0,
    Europe: 1,
    Asia: 2,
    Oceania: 3,
    'South America': 4,
    Africa: 5,
    'Middle East': 6,
    Other: 7
  };

  function lngLatToPercent(lng, lat) {
    var x = ((lng + 180) / 360) * 100;
    var y = ((90 - lat) / 180) * 100;
    return { x: x, y: y };
  }

  function countryToMapPoint(country, lng, lat, photoMode) {
    var code = (country.code || '').toUpperCase();
    var customX = parseFloat(country.marker_x);
    var customY = parseFloat(country.marker_y);

    if (
      country.override_marker_position &&
      isFinite(customX) &&
      isFinite(customY) &&
      customX >= 0 &&
      customX <= 100 &&
      customY >= 0 &&
      customY <= 100
    ) {
      return { x: customX, y: customY };
    }

    if (photoMode && ISO_PHOTO_XY[code]) {
      return { x: ISO_PHOTO_XY[code][0], y: ISO_PHOTO_XY[code][1] };
    }
    if (photoMode) {
      return null;
    }
    return lngLatToPercent(lng, lat);
  }

  function syncMarkersLayerToImage(mapWrap, markersLayer) {
    var stage = mapWrap.querySelector('[data-lp-dealer-map-stage]') || mapWrap;
    var img = stage.querySelector('img.lp-dealer-global-map__svg');
    if (!img) {
      markersLayer.style.left = '0';
      markersLayer.style.top = '0';
      markersLayer.style.width = '100%';
      markersLayer.style.height = '100%';
      return;
    }

    function apply() {
      applyMapWrapAspect(mapWrap, img);
      var box = getContainedImageBox(img);
      markersLayer.style.left = box.offsetX + 'px';
      markersLayer.style.top = box.offsetY + 'px';
      markersLayer.style.width = box.width + 'px';
      markersLayer.style.height = box.height + 'px';
    }

    apply();
    if (!img.complete) {
      img.addEventListener('load', apply, { once: true });
    }
    if (!mapWrap._lpDealerMapResizeBound) {
      mapWrap._lpDealerMapResizeBound = true;
      var resizeTimer;
      window.addEventListener('resize', function () {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(function () {
          apply();
          if (mapWrap.getAttribute('data-lp-dealer-map-photo') === 'true') {
            var layer = mapWrap.querySelector('[data-lp-dealer-map-markers]');
            if (layer) syncMarkersLayerToImage(mapWrap, layer);
          }
        }, 120);
      });
    }
  }

  function initMap(root) {
    if (root.getAttribute('data-lp-dealer-map-initialized') === 'true') return;
    var dataEl = root.querySelector('[data-lp-dealer-map-json]');
    if (!dataEl) return;
    var countries;
    try {
      countries = JSON.parse(dataEl.textContent);
    } catch (e) {
      return;
    }

    var mapWrap = root.querySelector('[data-lp-dealer-map-wrap]');
    var markersLayer = root.querySelector('[data-lp-dealer-map-markers]');
    if (!markersLayer || !mapWrap) return;

    var photoMode = mapWrap.getAttribute('data-lp-dealer-map-photo') === 'true';
    if (photoMode) rebuildPhotoXY();

    countries.sort(function (a, b) {
      var ra = REGION_ORDER[a.region] != null ? REGION_ORDER[a.region] : 99;
      var rb = REGION_ORDER[b.region] != null ? REGION_ORDER[b.region] : 99;
      if (ra !== rb) return ra - rb;
      return (a.name || '').localeCompare(b.name || '');
    });

    var reduced = prefersReducedMotion();

    function renderMarkers() {
      markersLayer.innerHTML = '';
      syncMarkersLayerToImage(mapWrap, markersLayer);

      countries.forEach(function (c) {
        if (!c.show_marker) return;
        var code = (c.code || '').toUpperCase();
        var coords = ISO_COORDS[code];
        if (!coords) return;
        var pt = countryToMapPoint(c, coords[0], coords[1], photoMode);
        if (!pt) return;

        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'lp-dealer-global-map__marker';
        btn.style.left = pt.x + '%';
        btn.style.top = pt.y + '%';
        btn.setAttribute('data-country-code', code);
        btn.setAttribute('aria-label', c.name || code);
        if (c.note) btn.setAttribute('title', c.note);

        var tip = document.createElement('span');
        tip.className = 'lp-dealer-global-map__tooltip';
        tip.textContent = c.name || code;
        btn.appendChild(tip);

        btn.addEventListener('click', function () {
          if (!window.matchMedia('(hover: none)').matches) return;
          var open = btn.classList.contains('is-tooltip-open');
          markersLayer.querySelectorAll('.is-tooltip-open').forEach(function (m) {
            m.classList.remove('is-tooltip-open');
          });
          if (!open) btn.classList.add('is-tooltip-open');
        });

        markersLayer.appendChild(btn);
      });

      return markersLayer.querySelectorAll('.lp-dealer-global-map__marker');
    }

    var markerEls = renderMarkers();
    var img = mapWrap.querySelector('img.lp-dealer-global-map__svg');
    if (img && !img.complete) {
      img.addEventListener(
        'load',
        function () {
          markerEls = renderMarkers();
          startReveal(markerEls);
        },
        { once: true }
      );
    }

    function startReveal(markerNodeList) {
      var els = markerNodeList || markersLayer.querySelectorAll('.lp-dealer-global-map__marker');

      function revealMarkers() {
        els.forEach(function (m, i) {
          if (reduced) {
            m.classList.add('is-visible');
            return;
          }
          setTimeout(function () {
            m.classList.add('is-visible');
          }, i * 45);
        });
      }

      if (reduced) {
        mapWrap.classList.add('is-visible');
        revealMarkers();
        return;
      }

      var mapIo = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            mapWrap.classList.add('is-visible');
            revealMarkers();
            mapIo.disconnect();
          });
        },
        { threshold: 0.12 }
      );
      mapIo.observe(mapWrap);
    }

    if (!img || img.complete) {
      startReveal(markerEls);
    }

    document.addEventListener('click', function (e) {
      if (!root.contains(e.target)) {
        markersLayer.querySelectorAll('.is-tooltip-open').forEach(function (m) {
          m.classList.remove('is-tooltip-open');
        });
      }
    });

    root.setAttribute('data-lp-dealer-map-initialized', 'true');
  }

  function initMaps() {
    document.querySelectorAll('[data-lp-dealer-global-map]').forEach(initMap);
  }

  function onReady() {
    initHeroScroll();
    initProcessReveal();
    initMaps();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', onReady);
  } else {
    onReady();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target;
    var mapRoot = section.querySelector('[data-lp-dealer-global-map]');
    if (mapRoot) initMap(mapRoot);
    if (section.querySelector('[data-lp-dealer-process]')) {
      initProcessReveal();
    }
    initHeroScroll();
  });
})();
